import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logoImage from '../Assets/Logo.png';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" className="logo-link">
              <img src={logoImage} alt="Enculture" className="logo-img" />
            </Link>
          </div>
          <nav className="nav">
            {/* Navigation links removed as requested */}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
